(() => {
  const SELECTOR = '[data-bcu-service-gallery]';

  const initialiseGallery = (gallery) => {
    if (!(gallery instanceof HTMLElement) || gallery.dataset.bcuServiceGalleryReady === 'true') return;

    const slides = Array.from(gallery.querySelectorAll('[data-bcu-service-gallery-slide]'));
    const previousButton = gallery.querySelector('[data-bcu-service-gallery-previous]');
    const nextButton = gallery.querySelector('[data-bcu-service-gallery-next]');
    const status = gallery.querySelector('[data-bcu-service-gallery-status]');

    gallery.dataset.bcuServiceGalleryReady = 'true';
    if (slides.length < 2 || !previousButton || !nextButton) return;

    const interval = Math.max(2000, Number(gallery.dataset.bcuServiceGalleryInterval) || 2500);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let currentIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer = 0;
    let pointerInside = false;
    let focusInside = false;

    const stop = () => {
      if (!timer) return;
      window.clearInterval(timer);
      timer = 0;
    };

    const start = () => {
      stop();
      if (reducedMotion.matches || pointerInside || focusInside || document.hidden) return;
      timer = window.setInterval(() => show(currentIndex + 1), interval);
    };

    const show = (requestedIndex, announce = false) => {
      currentIndex = (requestedIndex + slides.length) % slides.length;

      slides.forEach((slide, index) => {
        const isActive = index === currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });

      if (status && announce) status.textContent = `Bild ${currentIndex + 1} von ${slides.length}`;
    };

    previousButton.addEventListener('click', () => {
      show(currentIndex - 1, true);
      start();
    });

    nextButton.addEventListener('click', () => {
      show(currentIndex + 1, true);
      start();
    });

    gallery.addEventListener('pointerenter', () => {
      pointerInside = true;
      stop();
    });

    gallery.addEventListener('pointerleave', () => {
      pointerInside = false;
      start();
    });

    gallery.addEventListener('focusin', () => {
      focusInside = true;
      stop();
    });

    gallery.addEventListener('focusout', (event) => {
      if (event.relatedTarget instanceof Node && gallery.contains(event.relatedTarget)) return;
      focusInside = false;
      start();
    });

    document.addEventListener('visibilitychange', start);
    reducedMotion.addEventListener?.('change', start);
    start();
  };

  const initialiseWithin = (root = document) => {
    if (root instanceof HTMLElement && root.matches(SELECTOR)) initialiseGallery(root);
    root.querySelectorAll?.(SELECTOR).forEach(initialiseGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseWithin());
  } else {
    initialiseWithin();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseWithin(event.target));
})();
